<template>
    <v-container grid-list-xs>
      

    <v-divider class="mt-12"></v-divider>
    <h2 class="text-center red--text">Fotos - {{$route.params.ad}}</h2>
    <v-divider></v-divider>
  
     <v-btn 
    block
    class="mx-auto"
    color="success" 
    dark @click="dialog=!dialog" >
    Agrega foto </v-btn>
     <v-layout row wrap pa-2>

        <v-flex xs12 class="pa-2">
                        <v-row >
                    <v-col
                        v-for="cate in filtra($route.params.ad)" :key="cate.foto"
                        cols="6"
                        xs="6"
                        sm="4"
                        md="3">

                        <v-card
                        class="pa-3 font-italic text-center"
                        outlined
                        tile
                        >
                                <v-img
                                :src="cate.foto"
                                aspect-ratio="1">
                                <template v-slot:placeholder>
                                    <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                                <v-card-actions>
                                <v-btn icon color="red">
                                <v-icon
                                 @click="eliminar($route.params.ad,cate.idfoto,$route.params.id)">fas fa-trash</v-icon>
                                </v-btn>
                                </v-card-actions>

                                </v-img>
                        </v-card>
                    </v-col>
                    </v-row>
        </v-flex>
    </v-layout>


             <v-dialog
              v-model="dialog"
              max-width="450px"
            >
      <v-card
        class="mx-auto "
        color="white"
        max-width="450px"
      >
          <v-form
              ref="form"
              class="pa-3"
              v-model="valid"
              lazy-validation
            >

            <v-file-input
                label="File input"
                filled
                v-model="selectedFile"
                prepend-icon="mdi-camera"
              ></v-file-input>

            </v-form>
            
        <v-card-actions>
          <v-btn
            block
          :disabled="!valid"
            color="success"
            class="mr-4"
            @click.stop="agregar($route.params.ad,create_UUID(),$route.params.id)"
          >
            Guardar
          </v-btn>

          <v-dialog
            v-model="progress"
            max-width="200"
            >
            <v-card>
                 <v-progress-circular
                  :rotate="90"
                  :size="200"
                  :width="15"
                  :value="Uploadvalue"
                  color="red"
                >
                  {{ Uploadvalue }}
                </v-progress-circular>
            </v-card>

         </v-dialog>


        </v-card-actions>

      </v-card>
    
     </v-dialog>
      </v-container>

</template>

<script>
import { db } from '../db'
import store from '@/store/index'
import paletaColores from '@/components/paletaColores'

  export default {
    name: 'gestionfotoscategoria',

    firebase:{
       categorias: db.database().ref("lineas")
    },

    data() {
        return {
        dialog:false,
        categorias:[],
        progress: false,
        selectedFile:null,
        Uploadvalue:0,
        picture:null,
        valid: true,
        idfoto:'',
        Nombre: '',
     
        }
      },
  
    
       methods: {
        filtra(ca){
            var cate
            for(var i=0;i<this.categorias.length;i++){
                if(this.categorias[i].nombre==ca){
                  return cate=this.categorias[i].fotos
                }
            }
               
        },

        agregar(n,a,ref){

        this.progress = true
         const storageRef = db.storage().ref(`/${ref}/${a}`)
         const task=storageRef.put(this.selectedFile)
         task.on('state_changed',snapshot=>{
           let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
           this.Uploadvalue = porcentaje
         },error=>{console.log(error.message)},
         ()=>{this.Uploadvalue=100;
              task.snapshot.ref.getDownloadURL().then((url)=>{
                this.picture = url;

                    console.log("exito")
                     db.database().ref(ref).child(n).child("fotos").child(a).set({
                       idfoto:a,
                       foto:this.picture
                       }
                    );
                this.selectedFile='',
                this.progress = false
                this.dialog= !this.dialog 
                console.log(this.picture)
              })
         }
         )
         },
            create_UUID(){
              var dt = new Date().getTime();
              var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                  var r = (dt + Math.random()*16)%16 | 0;
                  dt = Math.floor(dt/16);
                  return (c=='x' ? r :(r&0x3|0x8)).toString(16);
              });
              return uuid;
          },

        eliminar(n,a,ref){
             // Create a reference to the file to delete
              var desertRef = db.storage().ref(`/${ref}/${a}`)
              desertRef.delete().then(function() {
                  db.database().ref(ref).child(n).child("fotos").child(a).remove()
                console.log("exito")
              }).catch(function(error) {
                // Uh-oh, an error occurred!
                  console.log("fallo", error)
              });

              

            }

        }
  }
</script>